import React, { useEffect } from "react";
import * as LucideIcons from "lucide-react";
import "../styles/HowItWorks/HowItWorks.css";

const steps = [
  { step: 1, icon: "Search", title: "Search & Select", description: "Browse our wide range of services and select the one that meets your needs. Filter by category, rating, and price.", color: "bg-blue-100" },
  { step: 2, icon: "Calendar", title: "Book & Schedule", description: "Choose your preferred date and time slot. Our professionals are available 7 days a week for your convenience.", color: "bg-green-100" },
  { step: 3, icon: "CreditCard", title: "Secure Payment", description: "Pay securely through multiple payment options. No advance payment required - pay after service completion.", color: "bg-orange-100" },
  { step: 4, icon: "CheckCircle", title: "Service Complete", description: "Our verified professional arrives on time and completes the service. Rate your experience and get warranty.", color: "bg-purple-100" },
];

export default function HowItWorks() {
  useEffect(() => {
    // Render Lucide icons after component mounts
    Object.values(LucideIcons).forEach(Icon => {}); // Dummy call to ensure icons exist
  }, []);

  return (
    <section className="how-it-works-section">
      <div className="container">
        {/* Header */}
        <div className="header-text">
          <h2>How It Works</h2>
          <p>Get your home services done in just 4 simple steps. It's quick, easy, and completely hassle-free.</p>
        </div>

        {/* Desktop Steps */}
        <div className="desktop-steps">
          <div className="connection-line"></div>
          <div className="steps-grid">
            {steps.map((step) => {
              const IconComponent = LucideIcons[step.icon];
              return (
                <div key={step.step} className="step-card">
                  <div className={`step-icon ${step.color}`}>
                    {IconComponent && <IconComponent />}
                  </div>
                  <div className="step-number">{step.step}</div>
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Mobile Steps */}
        <div className="mobile-steps">
          {steps.map((step) => {
            const IconComponent = LucideIcons[step.icon];
            return (
              <div key={step.step} className="mobile-step">
                <div className={`step-icon ${step.color}`}>
                  {IconComponent && <IconComponent />}
                </div>
                <div>
                  <div className="step-number">{step.step}</div>
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="additional-info">
          <div className="info-card">
            <div className="info-title">100%</div>
            <div className="info-subtitle">Verified Professionals</div>
            <div className="info-text">Background checked & trained</div>
          </div>
          <div className="info-card">
            <div className="info-title">30 Days</div>
            <div className="info-subtitle">Service Warranty</div>
            <div className="info-text">Free rework if not satisfied</div>
          </div>
          <div className="info-card">
            <div className="info-title">24/7</div>
            <div className="info-subtitle">Customer Support</div>
            <div className="info-text">Always here to help you</div>
          </div>
        </div>
      </div>
    </section>
  );
}
